import React, { useEffect, useState } from 'react';
import '../../../css/announcement/Announcement.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import Sidenav from '../../shared/Sidenav';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import AddAnnouncementModal from './AddAnnouncementModal';
import EditModal from './AnnouncementEditModal';
import TextMessageModal from './TextMessageModal';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { AES, enc } from 'crypto-js';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ALLANNOUNCEMENTS_ENDPOINT, DELETEANNOUNCEMENT_ENDPOINT, DOWNLOAD_ENDPOINT } from '../../../Services/config/apiEndPoints';
// import Loader from 'react-loader';
import { store } from '../../../redux/_helpers/store';
import {successLoader,} from '../../../redux/_actions/loader.action';
import DeleteModal from '../../shared/DeleteRoleModal';
import SuccessModal from '../../shared/SuccessModal';
import { toast } from 'react-toastify';
import Cookies from 'cookies-js';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function Announcement(props) {
  const [announcementData, setAnnouncementData] = useState([]);
  const [editModalCall, setEditModalCall] = useState(false);
  const [hasOpen, setHasOpen] = useState(false);
  const [preview, setPreview] = useState(false);
  const [clickedAnnouncementText, setClickedAnnouncementText] = useState('');
  const [editIndex, setEditIndex] = useState('');
  const [hasOpenDelete, setHasOpenDelete] = useState(false);
  const [confirmedHasOpen, setConfirmedHasOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState('');
  // const [pageDisable, setPageDisable] = useState(false);
  // const [loaderTime, setLoaderTime] = useState(false);
  const pdfURL = utilityBaseURL + DOWNLOAD_ENDPOINT + "?documentPath=";
  var selectedTiles = [];
  let viewOnly = false;
  let roleData = useSelector(state => state.adminRoleReducer.roleData)
  const roleDataLength = roleData.length;
  for (let z = 0; z < roleDataLength; z++) {
    var rd = roleData[z].permissions;
    selectedTiles.push(rd)
  }
  selectedTiles.map(x =>
    x.map(md => {
      if (md.functionId == 22) {
        if (md.method.includes("View & Edit")) {
          viewOnly = true
        }
      }
    }))
  const onCloseModal = () => {
    window.location.reload();
    setHasOpen(false);
  };
  const onHandleUser = (index) => {
    setEditModalCall(true);
    setEditIndex(index)
    setHasOpen(true);
  }
  const onCloseDeleteModal = () => {
    setHasOpenDelete(false);
  }
  const confirmDelete = (index) => {
    ApiCall(
      'DELETE',
      utilityBaseURL + DELETEANNOUNCEMENT_ENDPOINT + `?announcementId=${announcementData[deleteIndex].announcementId}`,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ' x-cc-trace-id': '1234',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          console.log(apiData.message);
          setConfirmedHasOpen(true);
          setHasOpenDelete(false);
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
  }
  const onCloseConfirmed = () => {
    setConfirmedHasOpen(false);
    window.location.reload();
  }
  const onDeleteAnnouncement = (index) => {
    console.log("delete index", index);
    setDeleteIndex(index);
    setHasOpenDelete(true);
  }
  const onClosePreviewModal = () => {
    setPreview(false);
  };
  const onClickPreview = (textMeaasge) => {
    setClickedAnnouncementText(textMeaasge)
    setPreview(true);
  }
  const [hasOpenAdd, setHasOpenAdd] = useState(false);
  const onCloseAddModal = () => {
    setHasOpenAdd(false);
  };
  const onAddHandleUser = () => {
    setHasOpenAdd(true);
  }
  useEffect(() => {
    let unmounted = false;
    ApiCall(
      'GET',
      utilityBaseURL + ALLANNOUNCEMENTS_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ' x-cc-trace-id': '1234',
      },
    ).then((apiData) => {
      console.log(apiData)
      if (!unmounted) {
        if (apiData.flag !== -1) {
          if (apiData.flag === 500) {
            console.log("No Announcement");
          }
          else {
            console.log('I am 200!');
            setAnnouncementData(apiData);
            console.log(apiData)
          }
        } else {
          // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
      }
    });
    return () => { unmounted = true };
  }, []);
  const previewPdf = (index) => {
    let testAccess = Cookies.get('msAL_admin_dev');
    testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
    // setLoaderTime(true);
    // setPageDisable(true);
    store.dispatch(successLoader(false));
    var oReq = new XMLHttpRequest();
    var URLToPDF = pdfURL + announcementData[index].attachment;
    oReq.open("GET", URLToPDF, true);
    // with encryption
    oReq.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
    // without encryption
    // oReq.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
    oReq.responseType = "blob";
    oReq.onload = function () {
      // Once the file is downloaded, open a new window with the PDF
      // Remember to allow the POP-UPS in your browser
      const file = new Blob([oReq.response], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      // setLoaderTime(false);
      // setPageDisable(false);
      store.dispatch(successLoader(true));
      window.open(fileURL, "_blank");
    };
    oReq.send();
    // })
  }
  const getTime = (timeStamp) => {
    return new Date(timeStamp).toString().split(' ')[4].substring(0, 5)
  }
  const getDate = (timeStamp) => {
    let date = new Date(timeStamp).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  const getPublishTime = (timeStamp) => {
    return new Date(timeStamp).toGMTString().split(' ')[4].substring(0, 5)
  }
  const getPublishDate = (timeStamp) => {
    let date = new Date(timeStamp).toGMTString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  const onClosePublish = () => {
    setHasOpenAdd(false);
    window.location.reload();
  }
  return (
    <div className="outer1"><div className="outer1" id="outerdiv" >
      <MetaDecorator title={TitleDescription.announcementPageTitle} description={TitleDescription.announcementPageDescription} />
      <div class="container-fluid announcementHome" 
      // id={pageDisable ? "disabletrue" : ""}
      >
        {/* <Loader
          loaded={!loaderTime}
          lines={10}
          length={10}
          width={10}
          radius={10}
          corners={1}
          rotate={0}
          direction={1}
          color="#000"
          speed={1}
          trail={60}
          shadow={false}
          hwaccel={false}
          className='spinner'
          zIndex={2e9}
          top="50%"
          left="50%"
          scale={1.0}
          loadedClassName="loadedContent"
        /> */}
        <Sidenav />
        <div class="announcementsData">
          <h6 class="pt-2 pb-3" id="announcementTitle">Announcement</h6>
          <div className="viewOnlyDiv" style={{
            display:
              // role > 0 && 
              !viewOnly ? null : "none"
          }}>
            <img alt="View Only Access" src={viewAccess} />
            <span className="viewOnly">View Only Access</span>
          </div>
          <div className="announcementContainer">
            <table class="bg-white announcementtable" id="announcementHeading">
              <tbody>
                <tr>
                  <td id="headingSno" style={{ width: !viewOnly ? "7%" : "6.6%" }}>
                    S. No.
                </td>
                  <td id="headingTerminal" style={{ width: !viewOnly ? "18%" : "16.4%" }}>
                    Terminal
                </td>
                  <td id="headingCategory" style={{ width: !viewOnly ? "15.5%" : "15%" }}>
                    Announcement Category
                </td>
                  <td id="headingPublishdt" style={{ width: !viewOnly ? "16%" : "14%" }}>
                    Published Date & Time
                </td>
                  <td id="headingFromdt" style={{ width: !viewOnly ? "13%" : "12%" }}>
                    Effective Date & Time
                </td>
                  <td id="hedingTodt" style={{ width: !viewOnly ? "12%" : "11%" }}>
                    Expiry Date & Time
                </td>
                  <td id="headingMessage" style={{ width: !viewOnly ? "10.5%" : "10%" }}>
                    Text Message
                </td>
                  <td id="headingPdf" style={{ width: !viewOnly ? "auto" : "7.5%" }}>
                    PDF
                </td>
                  <td class="headingExtraTd" style={{
                    display:
                      !viewOnly ? "none" : null
                  }}></td>
                </tr>
              </tbody>
            </table>
            <div className="announcementContent">
              <table class=" announcementtable" >
                <tbody>
                  {
                    announcementData.map((data, index) =>
                      <tr key={index} id="annpuncementData">
                        <td class="announcementSnoTd" style={{ width: !viewOnly ? "7%" : "6.6%" }}>
                          {index + 1}
                        </td>
                        <td class="pb-3 pt-3" id="announcementtdname" style={{ width: !viewOnly ? "18%" : "16.4%" }}>
                          <div>
                            <div data-tip={data.ports.map((val, key) => (
                              val.portName
                            )).join(", ")}>
                              <div id="announcementdivdata" class="tooltip">
                                <div class="selectout"><div id="terminalselectAnnouncement" className="announcementDetails">
                                  {data.ports.map((val, key) => (
                                    <text key={key}>
                                      {val.portName.split(':')[0] + (key < data.ports.length - 1 ? ',' : '') + " "}
                                    </text>
                                  ))}</div></div></div></div>
                            <ReactTooltip place="bottom" effect='solid' arrowColor="#6F6F6F" backgroundColor="#6F6F6F" multiline={true} className="announcementReactTooltip" />
                          </div>
                        </td>
                        <td class="announcementCategoryTd" style={{ width: !viewOnly ? "16%" : "15%" }}>
                          {data.announcementCategory}
                        </td>
                        <td class="announcementPublishedDateTimeTd" style={{ width: !viewOnly ? "16%" : "14%" }}>
                          {getPublishDate(data.publishTime)} {getPublishTime(data.publishTime)}
                        </td>
                        <td class="announcementEffectiveDateTimeTd" style={{ width: !viewOnly ? "13%" : "12%" }}>
                          {getDate(data.announcementFrom)} {getTime(data.announcementFrom)}
                        </td>
                        <td class="announcementExpiryDateTimeTd" style={{ width: !viewOnly ? "12%" : "11%" }}>
                          {getDate(data.announcementTo)} {getTime(data.announcementTo)}
                        </td>
                        <td class="announcementMessageTd" style={{ width: !viewOnly ? "5%" : null }}>
                          {data.text.length === 0 ? <p className="notAvailable"></p> : <Link class="pb-3 pt-3 " id="previewColorBlue" className="previewText announcementsmall4"
                            onClick={() => { onClickPreview(data.text) }}>Preview</Link>}
                        </td>
                        <td class="announcementPdfTd">
                          {data.attachment.length === 0 ? <p className="notAvailablepdf"></p> : <small class="pb-3 pt-3 " className="announcementDetails announcementSmallPdf previewText" style={{ marginLeft: !viewOnly ? "35%" : "48%" }}>
                            <Link onClick={() => previewPdf(index)}
                              id="previewColorBlue"
                            >Preview</Link></small>}
                        </td>
                        <td id="announcementEditDeleteTd" style={{
                          display:
                            !viewOnly ? "none" : null
                        }}>
                          <div class="pl-3">
                            <div id="edb" class="text-right pl-3 pt-2 p-2 pr-2">
                              <div id="announcementdivpadd" >
                                <img src={require('../../../assets/images/edit.svg')} onClick={() => onHandleUser(index)} width="25" height="25" class="d-inline-block pr-2" alt="" loading="lazy" />
                              </div>
                              <div>
                                <img src={require('../../../assets/images/delete_enable.svg')} onClick={() => onDeleteAnnouncement(index)} width="25" height="25" class="d-inline-block pr-2" alt="" loading="lazy" />
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>
            <nav class="navbar navbar-light bg-white announcementnavpos" style={{
              display:
                !viewOnly ? "none" : null
            }}>
              <Link class="text-left" onClick={onAddHandleUser}>
                <img src={require('../../../assets/images/add.svg')} width="23" height="23" class="d-inline-block pr-1" alt="" loading="lazy" />
                <small class="pt-2 pb-2" className="addNewAnnouncement">Add New Announcement</small>
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </div>
      <TextMessageModal hasOpen={preview} onClick={onClosePreviewModal}>
        <div className="textMessageContent">
          <div class="textMessage">{clickedAnnouncementText}</div>
        </div>
      </TextMessageModal>
      {(editModalCall && hasOpen) &&
        <EditModal
          onClick={onCloseModal}
          editIndex={editIndex}
          announcementData={announcementData}
          onClosePublish={onCloseModal} />
      }
      {hasOpenAdd && <AddAnnouncementModal onClick={onCloseAddModal} onClosePublish={onClosePublish} />}
      <DeleteModal hasOpen={hasOpenDelete} onClick={onCloseDeleteModal} onYesClick={confirmDelete} >
        <p className="deletemodalText">Do you really want to delete this announcement?</p>
      </DeleteModal>
      <SuccessModal hasOpen={confirmedHasOpen} onClick={onCloseConfirmed}>
        <p className="confirmedText">Confirmed</p>
      </SuccessModal>
    </div>
  );
}
export default Announcement;